import React, { Component } from 'react';
import Carousel from 'react-slick';
import * as actions from '../../actions';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Card, Radio, Paper } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { FormattedMessage, injectIntl } from 'react-intl';

const styles = {
    cardText: {
        margin: '10px',
        fontWeight: 'bold'
    }
};
class SideFilters extends Component {
    constructor(props) {
        super();
        this.state = {
            selectedCategory: props.selectedCategory
                ? props.selectedCategory
                : ''
        };
    }

    handleRadioChange = event => {
        this.setState({ selectedCategory: event.target.value });
        this.props.changeCategory(event.target.value);
    };
    render() {
        const { classes } = this.props;
        if (this.props.featuredProviderLoader) {
            return this.renderLoading();
        }
        return (
            <div>
                {/* <Card className="provider-text-right">
                    <h5 className={classes.cardText}>
                        <FormattedMessage
                            id="categories"
                            defaultMessage="Categories"
                        />
                    </h5>
                </Card> */}

                <div className="dir-alp-l3 dir-alp-l-com">
                    <h4>
                        <FormattedMessage
                            id="categories"
                            defaultMessage="Categories"
                        />
                    </h4>
                    <div className="dir-alp-l-com1 dir-alp-p3">
                        <form>
                            <ul>
                                {!this.props.categories.categoryLoader &&
                                    this.props.categories.categoryData.map(
                                        cat => {
                                            return (
                                                <li key={cat.key}>
                                                    <input
                                                        className="with-gap"
                                                        name="cat.key"
                                                        type="radio"
                                                        checked={
                                                            this.state
                                                                .selectedCategory ==
                                                            cat.key
                                                        }
                                                        onChange={event =>
                                                            this.handleRadioChange(
                                                                event
                                                            )
                                                        }
                                                        id={cat.key}
                                                        value={cat.key}
                                                    />

                                                    <label htmlFor={cat.key}>
                                                        {cat.heading}
                                                    </label>
                                                </li>
                                            );
                                        }
                                    )}
                            </ul>
                        </form>{' '}
                    </div>
                </div>
            </div>
        );
    }
}

const composedComponent = compose(
    withStyles(styles),
    connect(
        null,
        actions
    )
);
export default composedComponent(SideFilters);



// WEBPACK FOOTER //
// ./src/components/Providers/SideFilters.js